if (!customElements.get('adev-infinite-marquee')) {
    customElements.define('adev-infinite-marquee', class adevInfiniteMarquee extends HTMLElement {
        constructor() {
            super();
        }

        debounce(func, wait) {
            let timer;
            return (...args) => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    func.apply(this, args);
                }, wait);
            };
        }

        refresh(){
            const breakIfBelow = this.getAttribute('data-break-if-below');
            const hasBreakIfBelow = breakIfBelow !== null;

            if (hasBreakIfBelow) {
                const mediaQuery = window.matchMedia(`(max-width: ${breakIfBelow}px)`);
                
                if (mediaQuery.matches) {
                    return;
                }
            }

            const rows = Array.from(this.querySelectorAll('[data-adev-infinite-marquee="row"]'));
            if (rows.length === 0) return;
            
            rows.forEach(function (row) {
                row.classList.remove('adev-init');
            });

            const firstRow = rows[0];
            if (!firstRow) return;

            const groupWidth = firstRow.offsetWidth;
            const minTotalWidth = window.innerWidth * 2;

            if (groupWidth <= 0 || minTotalWidth <= 0) {
                console.warn('Invalid dimensions detected, skipping infinite marquee initialization');
                return;
            }

            rows.slice(1).forEach(function (row) {
                if (row && row.parentNode) {
                    row.remove();
                }
            });
            
            let totalWidth = groupWidth;
            let clonesNeeded = 0;
            const maxClones = 20;

            while (totalWidth < minTotalWidth && clonesNeeded < maxClones) {
                clonesNeeded++;
                totalWidth += groupWidth;
            }

            clonesNeeded = clonesNeeded < 1 ? 1 : clonesNeeded;
            
            const fragment = document.createDocumentFragment();
            for (let i = 0; i < clonesNeeded; i++) {
                const newRow = firstRow.cloneNode(true);
                fragment.appendChild(newRow);
            }

            this.appendChild(fragment);

            const newRows = Array.from(this.querySelectorAll('[data-adev-infinite-marquee="row"]'));
            newRows.forEach(function (row) {
                row.classList.add('adev-init');
            });
        }

        connectedCallback() {
            this.refresh();

            this._refreshMarquee = this.debounce(() => {
                this.refresh();
            }, 100);

            window.addEventListener('resize', this._refreshMarquee);
            window.addEventListener('orientationchange', this._refreshMarquee);
        }

        disconnectedCallback() {
            if (this._refreshMarquee) {
                window.removeEventListener('resize', this._refreshMarquee);
                window.removeEventListener('orientationchange', this._refreshMarquee);
            }
        }

    });
}